import React from 'react';

import AttentionMessage from './AttentionMessage';
import { InfoMessageProps } from './types';

const InfoMessage = ({ type = 'info', text, ...rest }: InfoMessageProps) => (
    <AttentionMessage type={type} text={text} {...rest} />
);

export default InfoMessage;
